import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StatusBar } from "../components/Shell";
import { useAppStore } from "../components/AppStore";
import { Sprout, HeartHandshake, Mail, Lock, User, Eye, ShieldCheck } from "lucide-react";

export default function Auth() {
  const navigate = useNavigate();
  const { role, setRole, setViewAs } = useAppStore();
  const [tab, setTab] = useState("login");

  const enter = () => {
    if (role === "empower") { setViewAs("neighbor"); navigate("/neighbor"); }
    else { setViewAs("kid"); navigate("/home"); }
  };

  return (
    <div className="gd-screen" style={{ background: "linear-gradient(180deg,#4a63d6 0%,#eef1fb 42%)" }}>
      <StatusBar dark={false} />
      <div className="gd-scroll px-6 pb-10">
        {/* logo */}
        <div className="mt-2 flex flex-col items-center">
          <div className="grid place-items-center rounded-2xl bg-white/95 p-3 shadow-lg">
            <img src="/assets/logo.png" alt="GEN-DO" className="h-14 w-14 object-contain" />
          </div>
          <div className="mt-3 text-2xl font-black text-white">GEN<span className="text-[#f5911e]">-DO</span></div>
          <div className="mt-1 rounded bg-[#f5911e] px-2 py-0.5 text-[9px] font-extrabold tracking-[2px] text-white">GROWING SUCCESS!</div>
        </div>

        {/* role toggle */}
        <div className="mt-6 flex gap-2 rounded-full bg-white/15 p-1 backdrop-blur">
          <RoleBtn active={role === "grow"} onClick={() => setRole("grow")} icon={Sprout} label="Parent/Do'er" />
          <RoleBtn active={role === "empower"} onClick={() => setRole("empower")} icon={HeartHandshake} label="Neighbor" />
        </div>

        {/* card */}
        <div className="gd-card mt-5 p-5">
          <div className="flex rounded-2xl bg-[#eef1fb] p-1">
            {["login", "signup"].map((t) => (
              <button key={t} onClick={() => setTab(t)} className="flex-1 rounded-xl py-2.5 text-sm font-bold transition-all gd-tap"
                style={{ background: tab === t ? "#fff" : "transparent", color: tab === t ? "#2b3f96" : "#8b93b5", boxShadow: tab === t ? "0 4px 12px rgba(31,42,82,.1)" : "none" }}>
                {t === "login" ? "Login" : "Sign Up"}
              </button>
            ))}
          </div>

          <div key={tab} className="gd-enter mt-5 space-y-4">
            {tab === "signup" && (
              <Field label="FULL NAME" icon={User} placeholder={role === "grow" ? "Your name" : "Neighbor"} />
            )}
            <Field label="EMAIL" icon={Mail} placeholder={role === "grow" ? "you@email.com" : "neighbor@email.com"} />
            <Field label="PASSWORD" icon={Lock} placeholder="••••••••" type="password" trailing={Eye} />

            {tab === "login" && (
              <div className="text-right">
                <button className="text-xs font-bold text-[#3b57c9]">Forgot password?</button>
              </div>
            )}

            <button onClick={enter} className="gd-blue-btn w-full rounded-2xl py-4 text-base font-extrabold">
              {tab === "login" ? "Login" : "Create Account"}
            </button>
          </div>
        </div>

        <div className="mt-5 flex items-center justify-center gap-2 rounded-xl bg-white/50 py-2.5 text-xs font-semibold text-[#2b3f96]">
          <ShieldCheck size={15} className="text-[#4fae3f]" />
          {role === "empower" ? "Posters complete a background check" : "Every job is parent-approved for safety"}
        </div>
      </div>
    </div>
  );
}

function RoleBtn({ active, onClick, icon: Icon, label }) {
  return (
    <button onClick={onClick} className="flex flex-1 items-center justify-center gap-1.5 rounded-full py-2.5 text-[12px] font-bold transition-all gd-tap"
      style={{ background: active ? "#fff" : "transparent", color: active ? "#2b3f96" : "rgba(255,255,255,.85)" }}>
      <Icon size={15} /> {label}
    </button>
  );
}

function Field({ label, icon: Icon, placeholder, type = "text", trailing: Trailing }) {
  return (
    <div>
      <label className="mb-1.5 block text-[11px] font-extrabold tracking-wide text-[#9aa3c0]">{label}</label>
      <div className="flex items-center gap-2.5 rounded-2xl border border-[#e6e9f5] bg-[#f7f8fd] px-4 py-3.5">
        <Icon size={17} className="text-[#a3abc9]" />
        <input type={type} placeholder={placeholder} className="w-full bg-transparent text-sm font-medium text-[#1f2a52] outline-none placeholder:text-[#b6bdd6]" />
        {Trailing && <Trailing size={17} className="text-[#a3abc9]" />}
      </div>
    </div>
  );
}
